module.exports = __webpack_public_path__ + "assets/3-Phoenix-SDR-Jobs.ddd2def7.png";